import React, { useState, useCallback, useEffect } from 'react';
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import { motion, AnimatePresence } from 'framer-motion';
import emailjs from 'emailjs-com';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpenText, faPaperPlane, faCircleNotch, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import './Contact.css';

const SERVICE_ID = "service_jxvj72a";
const TEMPLATE_ID = "template_vbzq5ff";
const USER_ID = "gFQ36NRawj3fPxO0B";

const Contact = () => {
    const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
    const [status, setStatus] = useState('idle');
    const [init, setInit] = useState(false);

    useEffect(() => {
        initParticlesEngine(async (engine) => {
            await loadSlim(engine);
        }).then(() => {
            setInit(true);
        });
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setStatus('sending');

        const templateParams = {
            user_name: formData.name,
            user_email: formData.email,
            user_subject: formData.subject,
            user_message: formData.message
        };

        emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, USER_ID)
            .then(() => {
                setStatus('success');
                setFormData({ name: '', email: '', subject: '', message: '' });
                setTimeout(() => setStatus('idle'), 5000);
            })
            .catch(() => {
                setStatus('error');
                setTimeout(() => setStatus('idle'), 5000);
            });
    };

    const particlesOptions = {
        fullScreen: { enable: false },
        fpsLimit: 120,
        interactivity: {
            events: {
                onHover: { enable: true, mode: "grab" },
                onClick: { enable: true, mode: "push" },
            },
            modes: {
                grab: { distance: 140, links: { opacity: 0.5 } },
                push: { quantity: 4 },
            },
        },
        particles: {
            color: { value: "#00d2ff" },
            links: {
                color: "#00d2ff",
                distance: 150,
                enable: true,
                opacity: 0.3,
                width: 1,
            },
            move: {
                enable: true,
                speed: 1.5,
                direction: "none",
                outModes: { default: "bounce" },
            },
            number: {
                density: { enable: true, area: 800 },
                value: 80,
            },
            opacity: { value: 0.5 },
            shape: { type: "circle" },
            size: { value: { min: 1, max: 3 } },
        },
        detectRetina: true,
    };

    return (
        <section id="contacto" className="contact-section">
            {init && (
                <div className="particles-wrapper">
                    <Particles id="tsparticles" options={particlesOptions} />
                </div>
            )}

            <div className="blue-light-effect"></div>

            <motion.div
                className="contact-container"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
            >
                <div className="contact-card glass-panel">
                    <header className="header-card">
                        <motion.div animate={{ y: [0, -10, 0] }} transition={{ duration: 4, repeat: Infinity }}>
                            <FontAwesomeIcon icon={faEnvelopeOpenText} className="blue-glow-icon" />
                        </motion.div>
                        <h2 className="blue-title">Contáctanos</h2>
                        <p className="blue-subtitle">Transformamos ideas en realidad.</p>
                    </header>

                    <form className="blue-form" onSubmit={handleSubmit}>
                        <div className="form-input-group">
                            <input type="text" name="name" placeholder="Tu Nombre" value={formData.name} onChange={handleChange} required />
                        </div>
                        <div className="form-input-group">
                            <input type="email" name="email" placeholder="Tu Email" value={formData.email} onChange={handleChange} required />
                        </div>
                        <div className="form-input-group">
                            <input type="text" name="subject" placeholder="Asunto" value={formData.subject} onChange={handleChange} required />
                        </div>
                        <div className="form-input-group">
                            <textarea
                                name="message"
                                placeholder="Tu mensaje..."
                                rows="5"
                                value={formData.message}
                                onChange={handleChange}
                                required
                            ></textarea>
                        </div>

                        <AnimatePresence mode="wait">
                            {status !== 'idle' && (
                                <motion.div
                                    initial={{ opacity: 0, y: -5 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    exit={{ opacity: 0 }}
                                    className={`status-alert ${status}`}
                                >
                                    {status === 'sending' && (
                                        <span className="msg-content">
                                            <FontAwesomeIcon icon={faCircleNotch} spin /> Enviando mensaje...
                                        </span>
                                    )}
                                    {status === 'success' && (
                                        <span className="msg-content">
                                            <FontAwesomeIcon icon={faCheckCircle} /> ¡Enviado con éxito!
                                        </span>
                                    )}
                                    {status === 'error' && (
                                        <span className="msg-content">❌ Error al enviar</span>
                                    )}
                                </motion.div>
                            )}
                        </AnimatePresence>

                        <motion.button
                            type="submit"
                            className="blue-submit-btn"
                            disabled={status === 'sending'}
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                        >
                            <span>Enviar Mensaje</span>
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </motion.button>
                    </form>
                </div>
            </motion.div>
        </section>
    );
};

export default Contact;